import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const LoginPage = () => {
  const { login, error, clearError } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    clearError();
    try {
      await login();
    } catch (err) {
      // Error is handled in context
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo" style={{ background: "transparent", width: "auto", height: "auto" }}>
          <img src="/tmc-onboarding-logo.png" alt="TMC Onboarding" style={{ height: "180px", width: "auto" }} />
        </div>
        <div className="support-suite-logo" style={{ marginTop: "20px", marginBottom: "10px" }}>
          <img src="/support-suite-logo.png" alt="Part of the TMC Support Suite" style={{ maxWidth: "280px", width: "100%", height: "auto" }} />
        </div>
        <p className="login-subtitle">
          Sign in with your Microsoft account to continue
        </p>

        {error && <div className="login-error">{error}</div>}

        <button
          className="login-btn"
          onClick={handleLogin}
          disabled={loading}
          data-testid="login-btn"
        >
          {loading ? (
            <>
              <div className="loading-spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></div>
              Signing in...
            </>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 23 23"
              >
                <path fill="#f35325" d="M1 1h10v10H1z" />
                <path fill="#81bc06" d="M12 1h10v10H12z" />
                <path fill="#05a6f0" d="M1 12h10v10H1z" />
                <path fill="#ffba08" d="M12 12h10v10H12z" />
              </svg>
              Sign in with Microsoft
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
